import React, { PureComponent } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Tooltip from '@atlaskit/tooltip';

import { Link } from 'src/router';
import urls from 'src/urls';
import { shortHash } from 'src/utils/short-hash';

import messages from './full-commit-link.i18n';

type FullCommitLinkProps = {
  hash: string;
  intl: InjectedIntl;
  path: string;
  repositoryFullSlug: string;
};

export default injectIntl(
  class FullCommitLink extends PureComponent<FullCommitLinkProps> {
    render() {
      const { hash, path, repositoryFullSlug } = this.props;

      if (!hash || !path || !repositoryFullSlug) {
        return null;
      }

      const commitUrl = urls.ui.fullCommit(repositoryFullSlug, hash);
      const tooltipContent = `${this.props.intl.formatMessage(
        messages.fullCommitTooltip,
        { trimmedHash: shortHash(hash) }
      )}`;

      return (
        <Tooltip content={tooltipContent}>
          <Link to={commitUrl} href={commitUrl}>
            <CustomThemeButton>
              <FormattedMessage {...messages.fullCommitLink} />
            </CustomThemeButton>
          </Link>
        </Tooltip>
      );
    }
  }
);
